import { load } from './_load.js';
export let trainingData = {
	count: 0,
	max: 0,
	each: 12,
	target: null,
	data: [],
	canLoadData: false,
	isAgree: false,
	init: function(){
		trainingData.target = document.querySelector("#training_data ul");
		//console.log(trainingData.target);
		if( trainingData.target ){
			trainingData.nav();
		}
	},
	nav: function(){
		let $btn = document.querySelector("button[data-agree]");
		$btn.removeEventListener("click", trainingData.agree, false);
		$btn.addEventListener("click", trainingData.agree, false);
	},
	agree: function(){
		let t = trainingData;
		if( !t.isAgree ){
			t.isAgree = true;
			t.load();
		}
	},
	load: function(){
		load.getJson("/assets/json/training_data.json").then( (res) => {
			//console.log(res);
			trainingData.data 	= res;
			
			trainingData.max 	= Math.ceil( res.length/trainingData.each );
			trainingData.makeHTML();
			document.querySelector("#nums .max").innerHTML = trainingData.max;
			document.querySelector("#training_data").classList.add("active");
			trainingData.canLoadData = true;
			setTimeout(function(){
				let $target = document.querySelector("#training_data");
				let posY = $target.getBoundingClientRect().top + window.pageYOffset - document.querySelector("#global_header").clientHeight;
				//console.log(posY);
				window.scrollTo({
					top: posY,
					behavior: "smooth"
				});
			}, 200);
		});
	},
	add: function(){
		let t = trainingData;
		//console.log("add", t.canLoadData, t.count, t.max);
		t.count++;
		if( t.count >= t.max ){
			t.count = t.max - 1;
		}else{
			document.querySelector("#training_data").classList.add("loading");
			document.querySelector("#nums .current").innerHTML = trainingData.count+1;
			t.makeHTML();
		}
	},
	makeHTML: function(){
		let start = trainingData.count*trainingData.each;
		let end = start + trainingData.each;
		let HTML = "";
		for(let i = start; i < end; i++){
			let d = trainingData.data[i];
			if(d){
				HTML += `<li>
							<figure>
								<img src="${d.img.url}" width="${d.img.width}" height="${d.img.height}" alt="${d.title}">
							</figure>
						</li>`;
			}
		}
		trainingData.target.insertAdjacentHTML("beforeend", HTML);
		trainingData.canLoadData = true;
		document.querySelector("#training_data").classList.remove("loading");
	}
}